import React from 'react'
import SectionHeading from '../../Common/SectionHeading'
import Link from 'next/link'
import Image from 'next/image'

export default function PastEventSection({data=null}) {
  return (
    <>
        {(data) &&
            <>
                <section className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto md:my-14 my-8">
                    <SectionHeading
                        title="Past Event Coverages Success Stories"
                        
                    />
                    <div className="grid grid-cols-12 gap-4">
                        {data?.map((item, index) => (
                            <div key={index} className={index === 1 || index === 2 ? 'md:col-span-8 col-span-12' : 'md:col-span-4 col-span-12'}>
                                <div className="group relative overflow-hidden h-full">
                                    <div className="h-full group-hover:before:content-[' '] group-hover:before:absolute group-hover:before:left-0 group-hover:before:top-0 group-hover:before:w-full group-hover:before:h-full group-hover:before:bg-[#3570ff] group-hover:before:opacity-70 group-hover:before:rounded group-hover:before:transition-all group-hover:before:duration-300 group-hover:before:ease-in-out">
                                        <Image priority={false} 
                                            width={2000} 
                                            height={2000} 
                                            src={process.env.IMG_CDN+item?.imageSrc}
                                            alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                                            className="w-full h-full rounded"
                                        />
                                    </div>
                                    <div className="w-full absolute group-hover:flex flex justify-between md:flex-row flex-col group-hover:items-center group-hover:justify-between left-0 md:bottom-[-180px] bottom-[-210px] group-hover:bottom-0 p-5 group-hover:transition-all group-hover:duration-300">
                                        <div className='w-full'>
                                            <span className="md:block hidden w-fit bg-yellow-500 text-white font-semibold text-xs leading-none py-1 px-3 rounded">Case Study</span>
                                            <h3  className="font-semibold text-lg leading-6 text-white mt-4 md:line-clamp-none line-clamp-2">{item?.title}</h3>
                                        </div>
                                        <div>
                                            <Link href={process.env.APP_URL+item?.link} className="whitespace-nowrap bg-white text-black py-4 px-6 inline-block font-semibold text-sm leading-none capitalize rounded">view details</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </>
        }
    </>
  )
}
